
const TEMPLATE_NAME = 'INVENTARY_EQUIPMENT';


const initialState = () => ({
    loading: false,
    data: null,
    
});
const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true,
      };
    }
    case `${TEMPLATE_NAME}_REJECTED`: {
      return {
        ...state,
        loading: false,
      };
    }
    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;

      return {
        ...state,
        loading: false,
        data: newData,

      };
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }

};
export default reducer;